import { Logo } from '../interfaces/Logo';

export const base_config = {
    header: {
        height: 80,
        centro: {
            fondoColor: 'var(--app-principal)',
            textoColor: '#ffffff',
            texto: 'Codelco',
            subtitulo: 'División El Teniente',
        },
        logoIzquierda: <Logo>{
            show: true,
            fondoColor: 'var(--app-destacado)',
            pathIcon: '/assets/imagenes/logoCodelco.png',
            textoIcon: 'Codelco',
            href: 'https://www.codelco.com',
        },
        logoDerecha: <Logo>{
            show: true,
            fondoColor: 'var(--app-principal)',
        },
    },
    footer: {
        height: 100,
        cuerpo: {
            fondoColor: 'var(--app-principal)',
            textoColor: '#ffffff',
            texto: 'Footer',
        },
        logoDerecha: <Logo>{
            fondoColor: 'var(--app-destacado)',
            pathIcon: '/assets/imagenes/logoCodelco.png',
            textoIcon: 'Codelco',
            href: 'https://www.codelco.com',
        },
    },
};
